export default function auth({ next, router }) {
  if (!localStorage.getItem("modo_dashboard_user_token")) {
    return router.push("/");
  }
  return next();
}
